export interface CustomerFormState {
  /** Customer card (POS); empty removes it. */
  barcode?: string
  name: string
  email?: string
  phone?: string
  status: 'active' | 'inactive'
  image_id?: string
  image_url_temp?: string
  /** Edit only; numbers kept as text in the form. Empty allowance means the store default. */
  credit_limit?: string
  offline_credit_allowance?: string
  /** POS price book id; `none` (or empty) for normal prices. */
  price_book_id?: string
}

export const customerFieldsConfig = () => {
  return {
    fields: {
      name: {
        rules: {
          required: 'Full name is required',
        },
      },
      email: {
        rules: {
          pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
            message: 'Invalid email address',
          },
        },
      },
      image_id: {
        // rules: {
        //     required: 'Image is required',
        // }
      },
      phone: {
        rules: {
          // Start with 01, followed by 9 digits
          pattern: {
            value: /^01\d{9}$/,
            message: 'Invalid phone number (e.g. 017XXXXXXXX)',
          },
        },
      },
    },
  }
}
